import { render } from "./Promotion.vue?vue&type=template&id=193428ae&scoped=true"
import script from "./Promotion.vue?vue&type=script&lang=js"
export * from "./Promotion.vue?vue&type=script&lang=js"

import "./Promotion.vue?vue&type=style&index=0&id=193428ae&scoped=true&lang=css"

import exportComponent from "/Users/ginea/Desktop/template_demo/vuejs-tailwindcss-portfolio-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193428ae"]])

export default __exports__